import { EthereumNetwork } from "@mezo/sdk"

import { ETHEREUM_NETWORK } from "./env"

const NETWORK_TO_TBTC_DEPOSIT_BITCOIN_RECOVERY_ADDRESS: Record<
  EthereumNetwork,
  string
> = {
  mainnet: "bc1qndkelvusyzsyc8rdmcaslhe5v8phuk64sugkuh",
  sepolia: "tb1q4eqmt2g7h2lx2v35la7h74vrgprgvg5mgalqf7",
  local: "tb1q4eqmt2g7h2lx2v35la7h74vrgprgvg5mgalqf7",
}

export const TBTC_DEPOSIT_BITCOIN_RECOVERY_ADDRESS =
  NETWORK_TO_TBTC_DEPOSIT_BITCOIN_RECOVERY_ADDRESS[ETHEREUM_NETWORK]

export const BTC_DEPOSIT_CONFIRMATION_INTERVAL = 10000
